class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    const element = (event.currentTarget !== null) ? event.currentTarget : event.target;
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = element.dataset.value;
    if (form) form.submit();
  }
}
customElements.define('localization-form', LocalizationForm);